// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__HIdSw","layoutList":"layout_layoutList__c6Wev","layoutTitle":"layout_layoutTitle__1b1hQ"};